import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef } from 'react';
import { StylesProvider, useModeTokens } from '@rexlabs/styling';
import CoreTag from './core';
import { getCompactTokens } from './modes/compact';
var baseTokens = {};
var modeTokens = [{
  mode: 'compact',
  tokens: getCompactTokens()
}];

function Tag(props, ref) {
  var tokens = useModeTokens(baseTokens, modeTokens);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(CoreTag, _extends({}, props, {
    ref: ref
  })));
}

export default /*#__PURE__*/forwardRef(Tag);